import { Link } from "react-router-dom";
import {
  Flame, ShieldCheck, Pipette, Droplets, Layers, Power, Bath, Wrench, ArrowRight, Building2,
} from "lucide-react";
import { useLang } from "@/lib/i18n";

const ICONS = { Flame, ShieldCheck, Pipette, Droplets, Layers, Power, Bath, Wrench, Building2 };

export default function ServiceCard({ service }) {
  const Icon = ICONS[service.icon] || Wrench;
  const { t } = useLang();
  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="group relative bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-xl hover:-translate-y-1 hover:border-brand-navy/30 transition-all duration-300 flex flex-col"
    >
      <div className="flex items-center justify-between">
        <div className="w-12 h-12 rounded-xl bg-brand-navy/10 text-brand-navy flex items-center justify-center group-hover:bg-brand-yellow group-hover:text-slate-900 transition-colors">
          <Icon size={22} />
        </div>
        <ArrowRight size={18} className="text-slate-300 group-hover:text-brand-yellow-dark group-hover:translate-x-1 transition-all" />
      </div>
      <h3 className="mt-5 font-heading text-lg font-semibold text-slate-900 leading-snug">
        {service.name}
      </h3>
      <p className="mt-2 text-sm text-slate-500 leading-relaxed flex-1">
        {service.short}
      </p>
      <p className="mt-4 text-xs font-semibold uppercase tracking-wider text-brand-yellow-dark">
        {t.cta.learnMore} →
      </p>
    </Link>
  );
}
